import { render, staticRenderFns } from "./LeadStatus.vue?vue&type=template&id=2db7ba8f&scoped=true"
import script from "./LeadStatus.vue?vue&type=script&lang=ts"
export * from "./LeadStatus.vue?vue&type=script&lang=ts"
import style0 from "./LeadStatus.vue?vue&type=style&index=0&id=2db7ba8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7ba8f",
  null
  
)

export default component.exports